import { CashFlowReport_s } from 'components/property/reports/report-styles'
// Data
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

interface RentRollRecoveryProps {
  property: object
}

const RentRollRecovery: FC<RentRollRecoveryProps> = (props) => {

  function submit():void {
    propertyReportService.propertyReport({
      report: 'rent_roll_recovery_input'
    });
  }

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <CashFlowReport_s>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Click 'Run Report' to view this report</Label_s>
        </div>
      </ReportForm_s>
    </CashFlowReport_s>
  )
}

export default RentRollRecovery
